import {add, format, isValid, parse, startOfToday, startOfDay} from 'date-fns'

export interface TimePart {
  hours: number
  minutes: number
}

const timePartPattern = /^\s*(\d|0\d|1\d|2[0-3])\s*(?::\s*([0-5]?\d))?\s*$/

export const parseTimePart = (value: string): TimePart => {
  const matchArray = value.match(timePartPattern) ?? []
  const [, hours = 0, minutes = 0] = matchArray
  return {
    hours: +hours,
    minutes: +minutes
  }
}

export const stringifyTimePart = (value: Date | TimePart): string => {
  if ('getTime' in value) {
    return stringifyTimePart(getTimePart(value))
  }
  const hours = leadingZero(value.hours)
  const minutes = leadingZero(value.minutes)
  return `${hours}:${minutes}`
}

export const getTimePart = (date: Date): TimePart => ({
  hours: date.getHours(),
  minutes: date.getMinutes()
})

export const replaceTimePart = (target: Date, newTime: TimePart): Date => {
  return add(startOfDay(target), newTime)
}

const datePartPattern = /^\d\d?.\d\d?.\d\d\d\d$/

export const parseDatePart = (
  value: string,
  referenceDate: Date = startOfToday()
): Date | undefined => {
  if (!datePartPattern.test(value)) {
    return undefined
  }
  const result = parse(value, 'd.M.yyyy', referenceDate)
  return isValid(result) ? result : undefined
}

export const stringifyDatePart = (date?: Date): string =>
  date ? format(date, 'd.MM.yyyy') : ''

const leadingZero = (n: number) => ('00' + n).slice(-2)
